import { render, staticRenderFns } from "./TheTestimoniesCarousel.vue?vue&type=template&id=51887f21&scoped=true&"
import script from "./TheTestimoniesCarousel.vue?vue&type=script&lang=js&"
export * from "./TheTestimoniesCarousel.vue?vue&type=script&lang=js&"
import style0 from "./TheTestimoniesCarousel.vue?vue&type=style&index=0&id=51887f21&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51887f21",
  null
  
)

export default component.exports